import { Component } from 'react';

const devMode = typeof import.meta !== 'undefined' && import.meta.env?.DEV;

function ehErroCarregamentoModulo(error) {
  const msg = error?.message || String(error || '');
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Loading chunk') ||
    msg.includes('dynamically imported module')
  );
}

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (ehErroCarregamentoModulo(error)) {
      const reloadKey = 'chunk_reload_timestamp';
      const lastReload = Number(sessionStorage.getItem(reloadKey) || 0);
      const now = Date.now();
      if (now - lastReload > 10000) {
        sessionStorage.setItem(reloadKey, String(now));
        window.location.reload();
        return;
      }
    }
    if (devMode) {
      console.error('[ErrorBoundary]', error, info);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const error = this.state.error;
    const isChunkError = ehErroCarregamentoModulo(error);
    const message = error?.message || String(error);
    const stack = error?.stack;

    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4 dark:bg-gray-900">
        <div className="w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-800 dark:bg-gray-800">
          <div className="flex items-center gap-3">
            <div className="flex size-10 items-center justify-center rounded-xl bg-amber-100 text-amber-600 dark:bg-amber-500/20 dark:text-amber-400">
              <svg className="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800 dark:text-white">
                {isChunkError ? "Nova versão da aplicação" : "Algo deu errado"}
              </h2>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {isChunkError
                  ? "Uma nova atualização foi implantada. Recarregue a página para atualizar os arquivos."
                  : "Ocorreu um erro inesperado ao carregar a página."}
              </p>
            </div>
          </div>

          <div className="mt-4 rounded-xl border border-gray-100 bg-gray-50 p-3 text-xs text-gray-700 dark:border-gray-700/50 dark:bg-gray-900/50 dark:text-gray-300">
            <pre className="whitespace-pre-wrap font-mono text-xs max-h-40 overflow-y-auto">
              {message}
              {devMode && stack ? `\n\n${stack}` : null}
            </pre>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              onClick={this.handleReload}
              className="inline-flex items-center gap-2 rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-brand-600"
            >
              🔄 Recarregar página
            </button>
          </div>
        </div>
      </div>
    );
  }
}
